import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {map, reduce, shareReplay} from "rxjs/operators";
import {forkJoin, Observable} from "rxjs";
import {GeneralService} from "../general.service";
import {StorageService} from "../storage.service";

@Injectable({
  providedIn: 'root'
})
export class TagService extends GeneralService {

  businessType;
  tagData$: Observable<any>;
  tagTypeData$: Observable<any>;
  tagData1$: Observable<any>;
  tagData2$: Observable<any>;

  constructor(
      public http: HttpClient,
      private storageService: StorageService,
    @Inject('httpBaseSettings') public httpBaseSettings: any
  ) {
    super(http, httpBaseSettings);
    this.setModelPath('/tag/tag');
    this.businessType = this.storageService.getBusinessTypeItem();

    this.tagData1$ = this.http.post(this.httpBase + '/tag/tag/search', {businessType: -1}).pipe(map(res => res['data']));
    this.tagData2$ = this.http.post(this.httpBase + '/tag/tag/search', {businessType: this.businessType}).pipe(map(res => res['data']));
  }

  getTagTypes() {
    this.businessType = this.storageService.getBusinessTypeItem();
    if (!this.tagTypeData$) {
      this.tagTypeData$ = forkJoin([
        this.http.post(this.httpBase + '/tag/tagType/search', {businessType: -1}).pipe(map(res => res['data']), shareReplay(1)),
        this.http.post(this.httpBase + '/tag/tagType/search', {businessType: this.businessType}).pipe(map(res => res['data']), shareReplay(1))
      ]).pipe(
          map(res => {
            const allTagTypes = res[0].concat(res[1]);
            allTagTypes.sort((a, b) => b.id - a.id);
            return allTagTypes
          }),
          shareReplay(1)
      );
    }
    setTimeout(() => {
      this.tagTypeData$ = null;
    }, 60000);
    return this.tagTypeData$;
  }

  getCurrentSubSysTags(): Observable<any> {
    if (!this.tagData$) {
      this.tagData$ = forkJoin([
        this.tagData1$,
        this.tagData2$
      ]).pipe(
          map(res => {
            const allTag = res[0].concat(res[1]);
            allTag.sort((a, b) => b.id - a.id);
            return allTag
          }),
          shareReplay(1)
      );
    }
    setTimeout(() => {
      this.tagData$ = null;
    }, 60000);
    return this.tagData$;
  }

  getTagDataByCategory(category) {
    return this.getCurrentSubSysTags().pipe(map(res => res.filter(d => d.canMatch === 0)));
  }

  getTagByGroup(groupId) {
    return this.http.post(this.httpBase + '/tag/tag/search', {tagGroupId: groupId}).pipe(map(res => res['data']));
  }

  getTagByTypeCode(tagTypeCode) {
    return this.http.get(this.httpBase + '/tag/tag/getAllTag',
      {params: {tagTypeCode: tagTypeCode, recuresive: 'true'}}).pipe(map(res => res['data']));
  }

  clearCache() {
    this.tagData$ = null;
    this.tagData1$ = null;
    this.tagData2$ = null;
    this.tagTypeData$ = null;
    super.clearCache();
  }
    // 人员的tag
    getSelectionList(param){
      return this.http.post(this.httpBase + '/tag/tag/search', param).pipe(map(res => res['data']));
    }

}
